import { Component, OnInit, ViewChild } from '@angular/core';
import { SaleTransactionListModel, SaleTransactionListQueryModel, SaleTransactionModel } from '../../../model/builk/package-sale/sale-transaction.model';
import { PackageSaleService } from '../../../service/api/builk/package-sale.service';
import { PageChangedEvent } from 'ngx-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { TaxInvoiceModalComponent } from '../shared/tax-invoice-modal/tax-invoice-modal.component';
import { AddQuotationModalComponent } from './add-quotation-modal/add-quotation-modal.component';
import { SuccessModalComponent } from '../shared/success-modal/success-modal.component';
import { ConfirmModalComponent } from '../../shared/confirm-modal/confirm-modal.component';
import { ApprovePayProjectTransactionModel } from '../../../model/builk/package-sale/approve-pay-project-transaction.model';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
  selector: 'app-package-sale',
  templateUrl: './package-sale.component.html',
  styleUrls: ['./package-sale.component.scss']
})
export class PackageSaleComponent implements OnInit {

  //ViewChild
  @ViewChild("taxinvoiceModal") taxinvoiceModal: TaxInvoiceModalComponent;
  @ViewChild("addQuotationModal") addQuotationModal: AddQuotationModalComponent;
  @ViewChild("successModal") successModal: SuccessModalComponent;
  @ViewChild("confirmModal") confirmModal: ConfirmModalComponent;

  // string
  searchText: string = '';
  tab: string = 'now';

  // boolean
  isLoading: boolean = false;
  isError: boolean = false;
  isExporting: boolean = false;
  isNow: boolean = true;
  isCustom: boolean = false;
  isApprove: boolean = false;

  // model
  queryModel: SaleTransactionListQueryModel = new SaleTransactionListQueryModel();
  transactionModel: SaleTransactionListModel = new SaleTransactionListModel();
  selectToConfirm: SaleTransactionModel;

  // array
  itemList: Array<SaleTransactionModel> = new Array<SaleTransactionModel>();
  transactionType: Array<{ value: any, label: string }> = [
    { value: 1, label: "Created" },
    { value: 2, label: "Waiting" },
    { value: 3, label: "Success" },
    { value: -1, label: "Fail" },
    { value: -10, label: "Cancel" },
  ];
  periodDate: Array<Date> = [];

  // number
  transactionTypeValue: number = 3;
  userSurrKey: number;

  // rxjs
  private inputChange: Subject<string> = new Subject<string>();
  private subscription: Subscription;

  constructor(
    private packageSaleService: PackageSaleService,
    private readonly localStorageService: LocalStorageService,
  ) {
    this.userSurrKey = this.localStorageService.get("userSurrKey");
  }

  ngOnInit() {
    this.initData();
    this.getSaleTransaction();
    this.subscription = this.inputChange.pipe(debounceTime(1000)).subscribe((keyword: string) => { // search after typing delay 1 sec
      this.onSearch(keyword);
    });
  }

  initData() {
    this.queryModel.pageNumber = 1;
    this.queryModel.pageSize = 10;
    this.queryModel.sortByDesc = true;
    this.queryModel.sortColumn = 'TransactionSurrKey';
    this.queryModel.textSearch = '';
    this.queryModel.status = this.transactionTypeValue;
  }

  getSaleTransaction() {
    this.isLoading = true;
    this.isError = false;
    this.packageSaleService.getSaleTransaction(this.queryModel).subscribe(res => {
      this.transactionModel = res;
      this.itemList = res.itemList;
      this.isLoading = false;
    }, err => {
      console.log(err.message);
      this.isLoading = false;
      this.isError = true;
    });
  }

  onFilterChange() {
    this.queryModel.status = this.transactionTypeValue;
    this.getSaleTransaction();
  }

  onPageChange(event: PageChangedEvent) {
    this.queryModel.pageNumber = event.page;
    this.getSaleTransaction();
  }

  getMethodType(method: number): string {
    let reposne = "";
    switch (method) {
      case 1:
        reposne = "Cash";
        break;
      case 2:
        reposne = "Credit";
        break;
      default:
        reposne = "None"
        break;
    }

    return reposne;
  }

  getTime(dateTime: Date): string {
    const now = new Date(dateTime);
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  onKeywordChange() {
    if(this.queryModel.textSearch != this.searchText) {
      // keyword has change
      this.inputChange.next(this.searchText);
    }
  }

  onSearch(keyword: string) {
    this.queryModel.textSearch = keyword;
    this.queryModel.pageNumber = 1;
    this.getSaleTransaction();
  }

  exportPackageReport() {
    this.isExporting = true;
    this.packageSaleService.exportSaleTransaction(this.queryModel).subscribe((res) => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = "sale_report_" + formatDate(Date(), 'ddMMyyyy', 'en-US');
      a.click();
      window.URL.revokeObjectURL(url);
      this.isExporting = false;
      a.remove();
    }, (err) => {
      this.isExporting = false;
      alert("Error Message : " + err.message)
    }, () => {
      this.isExporting = false;
    });
  }

  onBtnCustom(val: boolean) {
    this.isCustom = val;
    if (this.isCustom == false) {
      this.isNow = true;
      this.isCustom = false;
      this.queryModel.startDate = undefined;
      this.queryModel.endDate = undefined;
      this.getSaleTransaction();
    } else {
      this.isNow = false;
      this.isCustom = true;
      if (this.periodDate.length == 0) {
        this.periodDate = [];
        let dateTime = new Date();
        this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth(), 1))
        this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth() + 1, 0))
        this.queryModel.startDate = this.periodDate[0];
        this.queryModel.endDate = this.periodDate[1];
      }
      this.getSaleTransaction();
    }
  }

  onDateChange() {
    if (this.isCustom) {
      this.isNow = false;
      this.queryModel.startDate = this.periodDate[0];
      this.queryModel.endDate = this.periodDate[1];
      this.getSaleTransaction();
    } else {
      this.isNow = true;
      this.queryModel.startDate = undefined;
      this.queryModel.endDate = undefined;
      this.getSaleTransaction();
    }
  }

  onRequestInvoice(value: SaleTransactionModel) {
    let refId: string = (value.refOrder != undefined && value.refOrder != null) ? value.refOrder : value.transactionSurrKey.toString();
    this.taxinvoiceModal.openModal(refId);
    //this.router.navigate([PageLink.costcontrol.package.requesttaxinvoice, "package"], {queryParams: { ref: refId } });
  }

  openCreateQuotation() {
    this.addQuotationModal.openModal();
  }

  onQuotationSuccess() {
    this.successModal.openSuccessModal(true, 'Create quotation success');
    this.getSaleTransaction();
  }

  openConfirm(val: SaleTransactionModel) {
    this.selectToConfirm = val;
    this.confirmModal.show();
  }

  confirm() {
    if (this.selectToConfirm && this.userSurrKey) {
      this.isApprove = true;
      const model: ApprovePayProjectTransactionModel = {
        transactionSurrKey: this.selectToConfirm.transactionSurrKey,
        userSurrKey: this.userSurrKey
      };
      this.packageSaleService.approvePayProjectTransaction(model).subscribe(res => {
        if (res && res.data == true) {
          this.successModal.openSuccessModal(true);
          this.getSaleTransaction();
        } else {
          alert('Error at this time, try again later.');
        }
        this.isApprove = false;
      })
    }
  }
}
